export default __webpack_public_path__ + "static/media/nft-of-the-day.5f68ad37.png";